import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { AuthFacade } from '@mkp/auth/util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const isUnverifiedUserGuard = (): Observable<boolean | UrlTree> => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.isVerified$.pipe(
    map((verified) => {
      return !verified || router.parseUrl(AppConfig.routes.claimCompany);
    })
  );
};
